import React from 'react';

/**
 * Fallback renderer for unknown / unsupported item types.
 * Kept as a separate module so unit tests can mock it cleanly.
 */
export default function DefaultItem({ item }) {
  return (
    <div className="p-4 border border-red-500 rounded bg-red-50">
      <p className="text-red-700">
        Unknown item type: {item?.type}
      </p>
    </div>
  );
}


